<template>
  <div
    v-if="!isDismissed && tenant"
    class="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center px-6 pb-20 sm:pb-5 lg:px-8 z-30"
  >
    <div
      class="pointer-events-auto flex items-center justify-between gap-x-6 bg-brand-900 px-6 py-2.5 rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5"
    >
      <p class="text-sm leading-6 text-white">
        <span v-if="tenant">
          <Link
            v-if="hasBillingAccess"
            :href="route('settings.organisation.buildings', tenant.id)"
          >
            <strong class="font-semibold">{{ tenant.name }}</strong
            ><svg
              viewBox="0 0 2 2"
              class="mx-2 inline h-0.5 w-0.5 fill-current"
              aria-hidden="true"
            >
              <circle cx="1" cy="1" r="1" />
            </svg>
            <i18n-t keypath="components.trial_banner.ending" tag="span">
              <template v-slot:days>
                {{
                  differenceInDays(new Date(tenant.trial_ends_at), new Date())
                }}
              </template>
            </i18n-t>
          </Link>
          <span v-else>
            <strong class="font-semibold">{{ tenant.name }}</strong
            ><svg
              viewBox="0 0 2 2"
              class="mx-2 inline h-0.5 w-0.5 fill-current"
              aria-hidden="true"
            >
              <circle cx="1" cy="1" r="1" />
            </svg>
            <i18n-t keypath="components.trial_banner.ending" tag="span">
              <template v-slot:days>
                {{
                  differenceInDays(new Date(tenant.trial_ends_at), new Date())
                }}
              </template>
            </i18n-t>
          </span>
        </span>
      </p>
      <button type="button" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Dismiss</span>
        <XMarkIcon
          class="h-5 w-5 text-white"
          aria-hidden="true"
          @click="handleDismiss"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon } from "@heroicons/vue/20/solid";
import { ref } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import { differenceInDays } from "date-fns";
import { useCookies } from "vue3-cookies";
import route from "ziggy-js";

const { cookies } = useCookies();
const isDismissed = ref(!!cookies.get("hide_trial_info"));

const tenant = usePage().props.trial.tenant;
const hasBillingAccess = usePage().props.trial.has_billing_access;

const handleDismiss = () => {
  isDismissed.value = true;

  const tomorrow = new Date();
  tomorrow.setHours(24, 0, 0, 0);
  cookies.set("hide_trial_info", "yes", tomorrow);
};
</script>
